<template>
	<popup v-model="visable" type="bottom" :title="title" @close="visable=false">
		<div class="selectSingle flex between-v">
			<div class="list">
				<div @click="confirm(item)" class="item flex center" v-for="(item,index) in dataList" :key="index">{{item.label}}</div>
			</div>
		</div>
	</popup>
</template>

<script>
// import SelectSingle from "@manage/components/picker/selectSingle.vue";
// <SelectSingle ref="pickstatus" title="请选择比赛状态" :dataList="status" @confirm="currentTab=2"/>
export default {
	name: "selectSingle",
	props:{
		title:{},
		dataList:{}
	},
	data() {
		return {
			visable: false,
		};
	},
	methods: {
		show() {
			this.visable = true;
		},
		confirm(item) {
			this.$emit('confirm',item),
			this.visable = false;
		},
	},
};
</script>

<style lang="less" scoped>
.selectSingle {
	padding: 10/@rem 0 20/@rem;
	.list{
		.item{
			font-size: 16/@rem;
			height: 48/@rem;
			color: rgba(31, 30, 29, 0.7);
			&:active{
				color: #FFA216;
			}
		}
		.active{
			color: #FFA216;
		}
	}
}
</style>